import ajax from './../ajax';

export function requestCallbackApi(params) {
  return ajax('/callback_requests', {
    method: 'POST',
    body: {
      callback_request: {
        ...params
      }
    }
  });
}

export function getSeminarByTypeApi(seminar_type) {
  return ajax(`/get_seminars_by_seminar_type?seminar_type=${seminar_type}`, {
    method: 'GET'
  });
}



// WEBPACK FOOTER //
// ./src/api/v1/summerInternship.js